import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { FormsModule } from "@angular/forms";
import type { IEquipmentTypeInfo, Ticket, TicketDeliveryProduct } from "@kiraah-shared/common";
import { TranslateModule } from "@ngx-translate/core";
import type { MobileTicketWizardComponent } from "../../mobile-ticket-wizard-page.component";

/** Équivalent mobile de `TicketEquipmentTypeSelectionComponent` : catalogue type + vue « sélection ». */
@Component({
  selector: "mobile-ticket-vehicle-types-step",
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule],
  templateUrl: "./mobile-ticket-vehicle-types-step.component.html",
  styleUrl: "./mobile-ticket-vehicle-types-step.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileTicketEquipmentTypesStepComponent {
  readonly wizard = input.required<MobileTicketWizardComponent>();
  readonly ticket = input.required<Ticket>();

  protected lineTrack(index: number, line: TicketDeliveryProduct): string {
    return this.wizard().selectionLineTrack(index, line);
  }

  protected equipmentTypeCatalogTrack(index: number, row: IEquipmentTypeInfo): string {
    return this.wizard().equipmentTypeCatalogTrack(index, row);
  }
}
